import { isNumber } from "lodash";
import moment from "moment";
import BadgeListCellRenderer from "../../PPTPromosGrid/cell-renderers/BadgeListCellRenderer";
import SeverityCellRenderer from "../cell-renderers/SeverityCellRenderer";
import { OpenDrawerCellRenderer } from "../cell-renderers/OpenDrawerCellRenderer";

const formatDateCell = ({ value }) => {
  if (value == null || value === "") return "";
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DD") : String(value);
};

const formatCurrencyCell = ({ value, data }) =>
  value != null
    ? value.toLocaleString(undefined, {
        style: "currency",
        currency: data?.currency || "USD",
      })
    : "";

const formatPercentCell = ({ value }) =>
  isNumber(value)
    ? value.toLocaleString(undefined, {
        style: "percent",
        maximumFractionDigits: 2,
      })
    : value;

/**
 * Column shape for the "Client Discounts" lens — each row is one ClientDiscount.
 * Parent context columns (title / studio / format / territory) come first because
 * they're how operators orient: "I'm looking at Mufasa deals." Per-client
 * realization values follow.
 */
export const clientDiscountColumnDefs = [
  {
    field: "issueSeverity",
    headerName: "Status",
    width: 100,
    cellRenderer: SeverityCellRenderer,
  },
  {
    field: "client",
    headerName: "Client",
    width: 100,
  },
  {
    field: "title",
    headerName: "Title",
    flex: 2,
    minWidth: 200,
  },
  {
    field: "studio",
    headerName: "Studio",
    width: 120,
  },
  {
    field: "media",
    headerName: "Type",
    width: 110,
    cellRenderer: BadgeListCellRenderer,
  },
  {
    field: "format",
    headerName: "Format",
    width: 110,
    cellRenderer: BadgeListCellRenderer,
  },
  {
    field: "territory",
    headerName: "Territory",
    width: 110,
    cellRenderer: BadgeListCellRenderer,
  },
  {
    field: "rateCardLabel",
    headerName: "Rate Card",
    width: 130,
  },
  {
    field: "currency",
    headerName: "Currency",
    width: 100,
  },
  {
    field: "cost",
    headerName: "Cost",
    filter: "agNumberColumnFilter",
    width: 100,
    valueFormatter: formatCurrencyCell,
  },
  {
    field: "retail",
    headerName: "Retail",
    filter: "agNumberColumnFilter",
    width: 100,
    valueFormatter: formatCurrencyCell,
  },
  {
    field: "revShare",
    headerName: "Rev Share",
    filter: "agNumberColumnFilter",
    width: 120,
    valueFormatter: formatPercentCell,
  },
  {
    field: "termStart",
    headerName: "Start Date",
    filter: "agDateColumnFilter",
    width: 135,
    valueFormatter: formatDateCell,
  },
  {
    field: "termEnd",
    headerName: "End Date",
    filter: "agDateColumnFilter",
    width: 135,
    valueFormatter: formatDateCell,
  },
  {
    field: "language",
    headerName: "Language",
    width: 120,
    valueFormatter: ({ value }) =>
      Array.isArray(value) ? value.join(", ") : value || "",
  },
  {
    // "Open client discount details" action — pinned to the right edge so it's always reachable.
    // Opens the ClientDiscount drawer to show the full client-specific discount details.
    // OpenDrawerCellRenderer detects parentDiscountId on these rows and calls onClientDiscountRowClick.
    colId: "actions",
    headerName: "",
    width: 48,
    maxWidth: 48,
    pinned: "right",
    sortable: false,
    filter: false,
    resizable: false,
    suppressHeaderMenuButton: true,
    cellRenderer: OpenDrawerCellRenderer,
  },
];
